import React from 'react';

interface ErrorFallbackProps {
  error?: Error;
  resetError?: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetError }) => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-md">
        <div className="text-center">
          <h2 className="mb-4 text-2xl font-bold text-gray-800">Oops! Something went wrong</h2>
          <p className="mb-6 text-gray-600">
            We're sorry for the inconvenience. Please try again or contact support if the problem
            persists.
          </p>
          {error ? (
            <details className="mb-6 text-left">
              <summary className="cursor-pointer text-blue-600 hover:text-blue-800">
                Technical Details
              </summary>
              <pre className="mt-2 overflow-auto rounded bg-gray-100 p-4 text-sm">
                {error.message}
              </pre>
            </details>
          ) : null}
          <button
            type="button"
            onClick={resetError || (() => window.location.reload())}
            className="rounded bg-blue-600 px-6 py-2 text-white transition-colors hover:bg-blue-700"
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
